import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "mb-10 pt-lg-20"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/logos/logo-blue-hewtee.png",
    class: "h-80px"
  })
], -1)
const _hoisted_4 = { class: "pt-lg-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder fs-3x text-gray-700" }, "Хуудас олдсонгүй", -1)
const _hoisted_6 = { class: "fw-bold fs-3 text-gray-600 mb-15" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/reference",
    class: "btn btn-ла btn-primary fw-bolder"
  }, "Эхлэл")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center fw-bold fs-6" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-hover-primary px-2" }, " 2021 © Монголбанк. Зээлийн мэдээллийн систем ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, " Зөв бичсэн эсэхээ нягтална уу. " + _toDisplayString(this.$route.redirectedFrom
              ? "Зам: " + this.$route.redirectedFrom.fullPath
              : ""), 1),
        _hoisted_7
      ])
    ]),
    _hoisted_8
  ]))
}